import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignVerticalDistributeEnd: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '5', y: '14', width: '14', height: '6', rx: '2' }],
    ['rect', { x: '7', y: '4', width: '10', height: '6', rx: '2' }],
    ['path', { d: 'M2 20h20' }],
    ['path', { d: 'M2 10h20' }],
  ],
];

export default AlignVerticalDistributeEnd;
